import API from '../../services/API'
import {
    GUARDIANS_GETTER,
    GUARDIANS_MUTATION_ENTIRE_GUARDIANS,
    GUARDIANS_MUTATION_DELETE_GUARDIAN,
    GUARDIANS_ACTION_GET_GUARDIANS,
    GUARDIANS_ACTION_DELETE_GUARDIAN
} from './guardians-types'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        guardians: []
    },

    getters: {
        [GUARDIANS_GETTER]: state => state.guardians
    },

    mutations: {
        [GUARDIANS_MUTATION_ENTIRE_GUARDIANS] (state, payload) { state.guardians = payload },
        [GUARDIANS_MUTATION_DELETE_GUARDIAN] (state, payload) {
            for (let i = 0; i < state.guardians.length; i++) {
                if (state.guardians[i].id === payload) {
                    state.guardians.splice(i, 1)
                }
            }
        }
    },

    actions: {
        [GUARDIANS_ACTION_GET_GUARDIANS] ({ commit }) {
            return new Promise(
                function (resolve, reject) {
                    API.loadGuardians()
                        .then((guardiansData) => {
                            commit(GUARDIANS_MUTATION_ENTIRE_GUARDIANS, guardiansData)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [GUARDIANS_ACTION_DELETE_GUARDIAN] ({commit, state}, payload) {
            API.deleteGuardian(payload)
                .then(() => {
                    OAlert.showSuccess('', i18n.t('feedback.guardianSucDelete'))
                    commit(GUARDIANS_MUTATION_DELETE_GUARDIAN, payload)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/guardians.js